export function isAnHtmlUIElementFocused() {
  if (!document.activeElement) {
    return false;
  }

  return (
    document.activeElement instanceof HTMLInputElement ||
    document.activeElement instanceof HTMLSelectElement ||
    document.activeElement instanceof HTMLTextAreaElement
  );
}
